import { render, staticRenderFns } from "./CompanyAnnouncementsBanner.vue?vue&type=template&id=e50f5300&scoped=true"
import script from "./CompanyAnnouncementsBanner.vue?vue&type=script&lang=js"
export * from "./CompanyAnnouncementsBanner.vue?vue&type=script&lang=js"
import style0 from "./CompanyAnnouncementsBanner.vue?vue&type=style&index=0&id=e50f5300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50f5300",
  null
  
)

export default component.exports